import React from 'react'
import "./pageBlog.css";

// import NavPage from "../navPage/NavPage";
import HeaderBlog from "../pageBlog/HeaderBlog";
 import BodyBlog from "../pageBlog/BodyBlog";
import Footer2 from "../footer2/Footer2";

function PageBlog() {
  return (
    <section>
       {/* <NavPage/> */}
       <HeaderBlog/>
       <BodyBlog/>
       <Footer2/>
    </section>
  )
}

export default PageBlog